import { render } from "./TextInput.vue?vue&type=template&id=33b3a497&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=33b3a497&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-33b3a497"

export default script